export const CREATE_PAYMENT_LAMBDA_URL = "https://7pohpk55j7nf44llvcrgbt247y0fqwgi.lambda-url.eu-west-3.on.aws/";
export const CONFIRM_PAYMENT_LAMBDA_URL = "https://mg45hscpyhmpqs4r7lgymaycua0rjmoo.lambda-url.eu-west-3.on.aws/";

export const TEST_CREATE_PAYMENT_LAMBDA_URL = "https://cwj2ww4tek4v7g5enuetbuxhb40iwuuu.lambda-url.eu-west-3.on.aws/";
export const TEST_CONFIRM_PAYMENT_LAMBDA_URL = "https://5rylb2br3hwtj6s37qskzpmbvm0qnrea.lambda-url.eu-west-3.on.aws/";
